module.exports = __webpack_public_path__ + "static/carousel-background-bc2886173b72cb8dcc99db6b35912372.jpg";